import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef } from '@angular/core';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { LayoutSidebarService } from '../sidebar';
import { LayoutContentbarsService } from './contentbars.service';
import { of } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import * as i0 from "@angular/core";
import * as i1 from "./contentbars.service";
import * as i2 from "../sidebar";
const _c0 = [[["", 8, "logo"]], [["", 8, "left"]], [["", 8, "right"]]];
const _c1 = [".logo", ".left", ".right"];
const _c2 = (a0, a1, a2, a3, a4) => ({
  "inline": a0,
  "transparent": a1,
  "has-sidebar": a2,
  "has-anchored-sidebar": a3,
  "mobile-sidebar-active": a4
});
function LayoutContentbarTopComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵlistener("click", function LayoutContentbarTopComponent_Conditional_0_Conditional_6_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.sidebar.showMenu($event));
    });
    i0.ɵɵelement(1, "ui-icon", 5);
    i0.ɵɵelementEnd();
  }
}
function LayoutContentbarTopComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵprojection(4);
    i0.ɵɵelementStart(5, "div", 1);
    i0.ɵɵconditionalCreate(6, LayoutContentbarTopComponent_Conditional_0_Conditional_6_Template, 2, 0, "a", 2);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵprojection(8, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 3);
    i0.ɵɵprojection(10, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(12, _c2, ctx_r1.inline, ctx_r1.background === false, i0.ɵɵpipeBind1(1, 4, ctx_r1.hasSidebar$), i0.ɵɵpipeBind1(2, 6, ctx_r1.hasAnchoredSidebar$), i0.ɵɵpipeBind1(3, 8, ctx_r1.sidebar.staticMenuMobileActive$)))("@topBarAnimation", undefined)("@.disabled", !ctx_r1.animate);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.showSidemenuToggle && i0.ɵɵpipeBind1(7, 10, ctx_r1.sidebar.hasSidebar$) ? 6 : -1);
  }
}
export let LayoutContentbarTopComponent = /*#__PURE__*/(() => {
  class LayoutContentbarTopComponent {
    get getToggleDrawer() {
      return 'true';
    }
    constructor(service, sidebar, cd) {
      this.service = service;
      this.sidebar = sidebar;
      this.cd = cd;
      this.inline = false;
      this.background = true;
      this.showSidemenuToggle = true;
      this.visible = true;
      this.animate = false;
      service.showTopBar$.subscribe(val => {
        this.visible = val;
        this.cd.markForCheck();
      });
      if (sidebar) {
        this.hasSidebar$ = sidebar.hasSidebar$.pipe(takeWhileAlive());
        this.hasAnchoredSidebar$ = sidebar.anchored$.pipe(takeWhileAlive());
      } else {
        this.hasSidebar$ = this.hasAnchoredSidebar$ = of(false);
      }
    }
    ngAfterViewInit() {
      // Skip initial animation as Safari is having trouble to render correctly
      setTimeout(() => {
        this.animate = true;
        this.cd.markForCheck();
      }, 50);
    }
    static {
      this.ɵfac = function LayoutContentbarTopComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutContentbarTopComponent)(i0.ɵɵdirectiveInject(i1.LayoutContentbarsService), i0.ɵɵdirectiveInject(i2.LayoutSidebarService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutContentbarTopComponent,
        selectors: [["layout-contentbar-top"]],
        hostVars: 1,
        hostBindings: function LayoutContentbarTopComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@topBarAnimation", ctx.getToggleDrawer);
          }
        },
        inputs: {
          inline: "inline",
          background: "background",
          showSidemenuToggle: "showSidemenuToggle"
        },
        ngContentSelectors: _c1,
        decls: 1,
        vars: 1,
        consts: [[1, "layout-topbar", 3, "ngClass"], [1, "layout-topbar-menu-wrapper", "left"], ["href", "#", "id", "layout-menu-btn", 1, "menu-btn"], [1, "layout-topbar-menu-wrapper", "right"], ["href", "#", "id", "layout-menu-btn", 1, "menu-btn", 3, "click"], ["icon", "bars"]],
        template: function LayoutContentbarTopComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵconditionalCreate(0, LayoutContentbarTopComponent_Conditional_0_Template, 11, 18, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.visible ? 0 : -1);
          }
        },
        dependencies: [NgClass, UiIconComponent, AsyncPipe],
        styles: [".layout-topbar[_ngcontent-%COMP%]{position:fixed;left:0;right:0;background-color:var(--topbarBgColor);padding:0;z-index:999;height:var(--topbarHeight);display:flex;justify-content:center;flex-wrap:wrap;transition:left .3s}.layout-topbar[_ngcontent-%COMP%]   .menu-btn[_ngcontent-%COMP%]{vertical-align:top;padding:4px 6px 2px;margin:0 10px 0 0;font-size:24px;color:var(--topbarIconColor);line-height:1;transition:all .3s;display:none}.layout-topbar[_ngcontent-%COMP%]   .menu-btn[_ngcontent-%COMP%]:hover{color:var(--topbarHoverIconColor)}.layout-topbar.mobile-sidebar-active[_ngcontent-%COMP%]   .menu-btn[_ngcontent-%COMP%]{color:var(--primaryTextColor);background:var(--primaryColor)}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;height:100%;justify-content:flex-start;padding:0 0 0 10px}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper.left[_ngcontent-%COMP%]{flex:1}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper.right[_ngcontent-%COMP%]{justify-content:flex-end;padding:0 10px 0 0}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]   .topbar-menu-btn[_ngcontent-%COMP%]{display:none;position:relative;top:-4px}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]   .topbar-menu-btn[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:40px;height:40px;vertical-align:middle}.layout-topbar.inline[_ngcontent-%COMP%]{position:relative;padding:0}.layout-topbar.inline[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{display:flex;align-items:center}.layout-topbar.inline[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]{padding:0}.layout-topbar.transparent[_ngcontent-%COMP%]{background-color:transparent!important}.layout-topbar[_ngcontent-%COMP%]     .logo{height:100%;display:inline-block}.layout-topbar[_ngcontent-%COMP%]     .logo app-logo{width:auto;height:100%}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .ui-menubar{border:none!important;margin:0!important}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .page-title{font-size:1.3rem;margin:0;line-height:1.2}@media (max-width: 600px){.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .page-title{font-size:1rem;line-height:1.2}}@media (max-width: 480px){.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .page-title{font-size:.85rem}}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu{list-style-type:none;padding:0;display:inline-block;vertical-align:middle;margin:4px 0 0}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu{display:flex;align-items:center}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu a:hover{cursor:pointer}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu .topbar-badge{width:16px;height:16px;text-align:center;background-color:var(--menuitemBadgeBgColor);color:var(--menuitemBadgeTextColor);font-size:-1em;font-weight:700;line-height:16px;border-radius:50%}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu>li{float:none;display:inline-block;margin-left:14px;position:relative}.layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu>li>a, .layout-topbar[_ngcontent-%COMP%]     .layout-topbar-menu-wrapper .topbar-menu>li>span{padding:18px 2px;color:var(--textColor);position:relative;display:block}[ui-theme=contrast][_nghost-%COMP%]   .layout-topbar[_ngcontent-%COMP%], [ui-theme=contrast]   [_nghost-%COMP%]   .layout-topbar[_ngcontent-%COMP%]{border-bottom:var(--basicPanelBorder)}@media (max-width: 1279px){.layout-topbar[_ngcontent-%COMP%]   .menu-btn[_ngcontent-%COMP%]{display:inline-block}}@media (max-width: 959px){.layout-topbar[_ngcontent-%COMP%]{width:100%}.layout-topbar[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{display:block}.layout-topbar[_ngcontent-%COMP%]   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]   .topbar-menu-btn[_ngcontent-%COMP%]{display:inline-block}.layout-topbar[_ngcontent-%COMP%]   .topbar-search[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{width:150px}}@media (max-width: 767px){.layout-topbar[_ngcontent-%COMP%]:not(.inline){height:var(--topbarHeight);display:flex;justify-content:center}.layout-topbar[_ngcontent-%COMP%]:not(.inline)   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]{height:initial}.logo[_ngcontent-%COMP%] + .layout-topbar[_ngcontent-%COMP%]:not(.inline)   .layout-topbar-menu-wrapper[_ngcontent-%COMP%]{margin-left:0}}"],
        data: {
          animation: [trigger('topBarAnimation', [state('void', style({
            transform: "translateY(-80px)"
          })), transition('void <=> *', animate(400))])]
        },
        changeDetection: 0
      });
    }
  }
  return LayoutContentbarTopComponent;
})();